// @flow
import {KEY_COOKIE_BANNER} from 'modules/game/constants';

type TGame = {
    name?: string,
};

type TGameState = {
    data: TGame,
    cookieBanner: boolean
};
const initialState: TGameState = {
    data: {},
    cookieBanner: localStorage.getItem(KEY_COOKIE_BANNER)
};

type TSetGame = {payload: TGame, type: 'SET_GAME'};
type TSetCookieBanner = {type: 'SET_COOKIE_BANNER'};

type TGameActionList = TSetGame | TSetCookieBanner;

function gameReducer(state: TGameState = initialState, {type, payload}: TGameActionList) {
    switch (type) {
        case 'SET_GAME':
            return {
                ...state,
                data: payload,
            };
        case 'SET_COOKIE_BANNER':
            return {
                ...state,
                cookieBanner: true,
            }
        default:
            return state;
    }
}

export {gameReducer};
export type {TGame, TSetGame, TGameState, TSetCookieBanner};
